// Navigation
export const NAVIGATION_ACTION = {
    CLICK: 'click',
    VIEW: 'view'
};

export const NAVIGATION_AREAS = {
    VIDEO: 'video',
    HOW_IT_WORKS: 'how_it_works',
    HEADER: 'header',
    HEADER_WEBMOBILE_OUTSIDE_MENU: 'HEADER_WEBMOBILE_OUTSIDE_MENU',
    SIGN_IN_MODAL: 'sign_in_modal',
    SIGN_UP_MODAL: 'sign_up_modal',
    SIGN_UP_EMAIL_MODAL: 'sign_up_email_modal',
    CANCEL_MEMBERSHIP_MODAL: 'cancel_membership_modal',
    FILTERS: 'filters',
    USER_PROFILE: 'user_profile',
    MAP: 'map',
    CAROUSEL: 'carousel',
    DETAILS: 'details',
    HOMECARD_RESULTS_PHOTO: 'homecard_results_photo',
    HOMECARD_RESULTS_FAVORITES: 'homecard_results_favorites',
    HOMECARD_MAP_PHOTO: 'homecard_map_photo',
    HOMECARD_MAP_FAVORITES: 'homecard_map_favorites',
    HEADER_AVATAR_MENU: 'header_avatar_menu',
    FILLING_PANEL: 'filling_panel',
    EXCHANGE_DETAILS: 'exchange_details',
    UPCOMING_EXCHANGES: 'upcoming_exchanges',
    HOMEPAGE_SPONSORSHIP: 'sponsorship',
    CONTACT_MODAL: 'contact_modal',
    CONTACT_MODAL_WARNING_TOO_SHORT: 'contact_modal_warning_too_short',
    EXCHANGE_RATE_MODAL: 'exchange_rate_modal ',
    VERIFY_YOUR_ACCOUNT_MODAL: 'verify_your_account_modal',
    CONTACT_MODAL_MESSAGE_SENT: 'contact_modal_message_sent'
};

export const NAVIGATION_TEXT = {
    SIGN_UP: 'sign_up',
    SIGN_UP_FACEBOOK: 'sign_up_facebook',
    SIGN_UP_APPLE: 'sign_up_apple',
    SIGN_UP_EMAIL: 'sign_up_email',
    SIGN_IN: 'sign_in',
    SIGN_IN_FACEBOOK: 'sign_in_facebook',
    SIGN_IN_APPLE: 'sign_in_apple',
    SIGN_IN_EMAIL: 'sign_in_email',
    CAROUSEL_SIGN_UP: 'carousel_sign_up',
    ACTIVATE_AUTO_RENEWAL: 'activate_auto_renewal',
    CANCEL_MY_MEMBERSHIP: 'cancel_my_membership',
    KEEP_IT_GOING: 'keep_it_going',
    ADD_TO_FAVORITES_SIGN_UP: 'add_to_favorites_sign_up',
    CONTACT_SIGN_UP: 'contact_sign_up',
    PHOTO_SIGN_UP: 'photo_sign_up',
    VERIFY_YOUR_ACCOUNT: 'verify_your_account',
    VERIFY_YOUR_PHONE: 'verify_your_phone',
    VERIFY_YOUR_NEW_HOME: 'verify_your_new_home',
    VERIFICATION_PENDING: 'verification_pending',
    VERIFICATION_DONE: 'verification_done',
    GET_YOUR_PHONE_VERIFIED: 'get_your_phone_verified',
    GET_YOUR_ACCOUNT_VERIFIED: 'get_your_account_verified',
    GET_YOUR_PROFILE_COMPLETED: 'get_your_profile_completed',
    COMPARE_TRANSPORT_OPTIONS: 'compare_transport_options',
    ACCEPT_INVITE_SIGN_UP: 'accept_invite_sign_up',
    TIPS_FROM_OUR_COMMUNITY: 'tips_from_our_community',
    USE_A_TEMPLATE_MESSAGE: 'use_a_template_message',
    KEEP_WRITING: 'keep_writing',
    SEND_ANYWAY: 'send_anyway',
    REQUEST_MESSAGE_TOO_SHORT: 'request_message_too_short',
    COMPLETE_THE_SURVEY: 'complete_the_survey',
    COPY_MY_LAST_REQUEST: 'copy_my_last_request',
    MESSAGE_SENT: 'message_sent',
    CLOSE: 'close',
    CONTACT_OTHER_MEMBERS: 'contact_other_members'
};
